import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationComissaoModalComponent } from './integration-comissao-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationComissaoModalComponent
    ],
    exports: [
        IntegrationComissaoModalComponent
    ]
})
export class IntegrationComissaoSharedModule { }
